// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ScenarioAttachment
 */
export interface ScenarioAttachment {
  /**
   *
   */
  id: number;
  /**
   *
   */
  code: string;
  /**
   *
   */
  attachmentUrl: string | null;
  /**
   *
   */
  uploadUrl?: string | null;
  /**
   *
   */
  taskId?: string | null;
}

/**
 * Check if a given object implements the ScenarioAttachment interface.
 */
export function instanceOfScenarioAttachment(value: object): value is ScenarioAttachment {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("code" in value) || value["code"] === undefined) return false;
  if (
    (!("attachmentUrl" in (value as Record<string, any>)) &&
      !("attachment_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["attachmentUrl"] === undefined &&
      (value as Record<string, any>)["attachment_url"] === undefined)
  )
    return false;
  return true;
}

export function ScenarioAttachmentFromJSON(json: any): ScenarioAttachment {
  return ScenarioAttachmentFromJSONTyped(json, false);
}

export function ScenarioAttachmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ScenarioAttachment {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    code: json["code"],
    attachmentUrl: json["attachment_url"],
    uploadUrl:
      json["upload_url"] === undefined
        ? undefined
        : json["upload_url"] === null
        ? null
        : json["upload_url"],
    taskId:
      json["task_id"] === undefined ? undefined : json["task_id"] === null ? null : json["task_id"],
  };
}

export function ScenarioAttachmentToJSON(json: any): ScenarioAttachment {
  return ScenarioAttachmentToJSONTyped(json, false);
}

export function ScenarioAttachmentToJSONTyped(
  value?: ScenarioAttachment | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    code: value["code"],
    attachment_url: value["attachmentUrl"],
    upload_url: value["uploadUrl"],
    task_id: value["taskId"],
  };
}
